var map = {
	"./admin/reducer.js": 377,
	"./album/reducer.js": 658,
	"./announcement/reducer.js": 659,
	"./class/reducer.js": 390,
	"./customer/reducer.js": 391,
	"./homework/reducer.js": 660,
	"./organization/reducer.js": 392,
	"./posts/reducer.js": 393,
	"./resource/reducer.js": 394,
	"./school/reducer.js": 661,
	"./sessions/reducer.js": 395,
	"./teacher/reducer.js": 396,
	"./user/reducer.js": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;